<template>
  <div class="row">
    <div class="col-12 flip-cards-container">
      
      <square-option
        v-for="(option, index) in selectedMenuItem"
        :key="index"
        :option="option"
      />
    </div>

    <div class="clearfix"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { name as userModuleName } from '@/modules/user/store'
import squareOption from '@/components/common/menu/SquareOption'
import {SECURITY_ROOT_NAV_MENU_ID} from '@/config.js';

export default {
  name: 'Home',
  components: {
    squareOption,
  },
  computed: {
    ...mapGetters(userModuleName, ['selectedMenuItem']),
  },
  mounted(){
    this.setMenuItemId({id: SECURITY_ROOT_NAV_MENU_ID});
  },
  methods:{
    ...mapActions(userModuleName, ['setMenuItemId']),
  }
}
</script>
<style scoped>
.flip-cards-container {
  display: flex;
  flex-wrap: wrap;
}

.flip-cards-container > div {
  min-height: 200px;
}
</style>
